import { render, staticRenderFns } from "./TrancheMarket.vue?vue&type=template&id=b359b328&scoped=true&"
import script from "./TrancheMarket.vue?vue&type=script&lang=js&"
export * from "./TrancheMarket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b359b328",
  null
  
)

export default component.exports